<script>
    import {t} from '$utils/lang.js';
    import Icon from '$component/Icon.svelte';
    import {twMerge} from "tailwind-merge";

    const {
        address,
        selected = false,
        showRadio = true,
        onselect = () => {},
        ondelete = null, // optional: when provided, renders a delete icon button
    } = $props();

    const isPackstation = $derived(address.street === 'Packstation');

    const cls = $derived(twMerge(
        "w-full text-left p-3.5 rounded-lg transition-colors cursor-pointer flex items-center gap-3",
        selected ? "border border-elm bg-elm/5" : "border border-gray-102 bg-white hover:border-gray-103"
    ));

    const countryShort = $derived(address.countryCode || '');

    // Regular-address one-liner (kept for non-packstation cases).
    const addressLine = $derived(() => {
        const parts = [];
        parts.push(`${address.street} ${address.streetNo}`);
        parts.push(`${address.zip} ${address.city}`);
        if (countryShort) parts.push(countryShort.toUpperCase());
        return parts.join(', ');
    });

    // Packstation-specific lines: station number, zip+city, postnummer. No
    // country — DHL Packstations are always in Germany, so the code is
    // redundant (and was showing the billing country, e.g. CH, by mistake).
    const packstationCityLine = $derived(() => `${address.zip} ${address.city}`);
</script>

<div class={cls} role="button" tabindex="0"
     onclick={() => onselect(address.id)}
     onkeydown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onselect(address.id); } }}
     data-checkout-action="select-address"
     data-address-id={address.id}
     data-select-nameed={selected}>
    {#if showRadio}
        <div class="shrink-0">
            {#if selected}
                <div class="size-3.5 rounded-full border-2 border-elm flex items-center justify-center">
                    <div class="size-2 rounded-full bg-elm"></div>
                </div>
            {:else}
                <div class="size-3.5 rounded-full border-2 border-gray-102"></div>
            {/if}
        </div>
    {/if}

    <div class="text-xs grow">
        {#if isPackstation}
            <div class="font-bold text-black">Packstation {address.streetNo}</div>
            {#if address.packstationStreet}
                <div class="text-gray-103">{address.packstationStreet}</div>
            {/if}
            <div class="text-gray-103">{packstationCityLine()}</div>
            {#if address.addInfo}
                <div class="text-gray-103">{t("Postnummer: {nummer}", {nummer: address.addInfo})}</div>
            {/if}
        {:else}
            {#if address.company || address.ustid}
                <div class="text-gray-103">{address.company || ''}{#if address.ustid}&nbsp;({address.ustid}){/if}</div>
            {/if}
            <div class="font-bold text-black">{address.name}</div>
            <div class="text-gray-103">{addressLine()}</div>
            {#if address.addInfo && address.addInfo !== address.company}
                <div class="text-gray-103">{address.addInfo}</div>
            {/if}
        {/if}
    </div>

    {#if ondelete}
        <button
            type="button"
            aria-label={t("Adresse löschen")}
            class="shrink-0 text-gray-103 hover:text-scarlet p-1 cursor-pointer transition-colors"
            onclick={(e) => { e.stopPropagation(); ondelete(address.id); }}
            data-checkout-action="delete-address"
            data-address-id={address.id}
        >
            <Icon name="trash" class="w-4 h-4"/>
        </button>
    {/if}
</div>
